import type { WorkflowProgressData } from '@app/application/workflows/types'
import type { ReconIconState, IconConfig } from '../types'

const RECON_STATES: Record<string, IconConfig> = {
  noDataEntered: {
    iconClass: 'i-no-reconciliation-needed no-text-properties',
    colorClass: '',
    tooltipKey: 'tooltips.reconciliation.icons.no_data_entered',
  },
  dataEntered: {
    iconClass: 'i-no-reconciliation-needed',
    colorClass: '',
    tooltipKey: 'tooltips.reconciliation.icons.data_entered',
  },
  complete: {
    iconClass: 'i-reconciled',
    colorClass: 'sf-c-success-light-1',
    tooltipKey: 'tooltips.reconciliation.icons.complete',
  },
  actionNeeded: {
    iconClass: 'i-unreconciled',
    colorClass: 'sf-c-danger-light-1',
    tooltipKey: 'tooltips.reconciliation.icons.action_needed',
  },
}

export function getReconIconState(
  apiObj: WorkflowProgressData
): ReconIconState {
  const isReconciliationText = apiObj.object_type === 'reconciliation_text'
  const notNeeded = isReconciliationText && apiObj.reconciliation_not_necessary

  if (notNeeded) {
    return apiObj.has_text_properties
      ? RECON_STATES.dataEntered
      : RECON_STATES.noDataEntered
  }

  return apiObj.reconciled ? RECON_STATES.complete : RECON_STATES.actionNeeded
}

export function shouldRenderReconIcon(
  apiObj: WorkflowProgressData | null | undefined
): boolean {
  if (!apiObj?.starred) {
    return false
  }

  if (apiObj.object_type === 'reconciliation_text') {
    return true
  }

  if (apiObj.object_type === 'account') {
    return apiObj.has_data
  }

  return false
}
